import styled, { css } from 'styled-components/native';

import { neutralDark, white } from '../../../constants/color';
import Image from '../../../elements/Image';
import Touchable from '../../../elements/Touchable';
import { LIST_GAP } from '../styles';
import { getItemBaseWidth } from '../utils';

export const containerMargin = 4;

const PADDING_VERTICAL = 8;
const PADDING_HORIZONTAL = 12;
const MARGIN_BOTTOM = 8;
const IMAGE_SECTION_MARGIN_TOP = 8;
const SUBTITLE_LINE_HEIGHT = 16;

// 圖片之間的空隙寬度
export const IMAGE_SPACE = 3;

// 圖片以外的寬度，這是用來做 `(width - SPACING) / 2` 計算圖片需要的寬度
const SPACING = PADDING_HORIZONTAL * 2 + IMAGE_SPACE;

export const getItemWidth = () => {
  const baseWidth = getItemBaseWidth(LIST_GAP - containerMargin);

  return baseWidth - containerMargin * 2;
};

// NOTE: Image 是方形的，寬度即是高度
export const getImageSize = width => {
  return (width - SPACING) / 2;
};

const containerHeight = css<{ height: number }>`
  height: ${({ height }) => height}px;
`;

export default {
  Container: styled.View<{ height: number }>`
    ${containerHeight}
    width: 100%;
    padding-left: ${containerMargin}px;
  `,
  Touchable: styled(Touchable)`
    flex: 1;
    background-color: ${white};
    padding: ${PADDING_VERTICAL}px ${PADDING_HORIZONTAL}px;
    border-radius: 5px;
    margin: 0px 0px ${MARGIN_BOTTOM}px 0px;
  `,
  SubtitleContainer: styled.View`
    flex-direction: row;
    align-items: center;
  `,
  Subtitle: styled.Text`
    color: ${neutralDark};
    font-size: 11px;
    line-height: ${SUBTITLE_LINE_HEIGHT}px;
    margin-right: 4px;
  `,
  ImagesSection: styled.View<{ isLarge: boolean }>`
    margin-top: ${IMAGE_SECTION_MARGIN_TOP}px;
    flex-direction: row;
    flex: 1;
    overflow: hidden;
    justify-content: ${({ isLarge }) =>
      isLarge ? 'flex-start' : 'space-between'};
  `,
  Image: styled(Image)<{ size: number; isLarge: boolean }>`
    width: ${({ size }) => size}px;
    height: ${({ size }) => size}px;
    margin-right: ${({ isLarge }) => (isLarge ? IMAGE_SPACE : 0)}px;
  `,
};
